import { createStyles, makeStyles } from "@material-ui/core/styles";


export default makeStyles(() => createStyles({
    root: {
        marginTop: "0.75em",
        flexGrow: 1,
    },
    actionButtons: {
        flexWrap: "nowrap",
        width: "auto",
        position: "absolute",
        zIndex: 4,
        bottom: 0,
        right: 0,
        paddingRight: "1rem",
        paddingBottom: "1rem",

        "@media screen and (max-width: 1280px)": {
            flexWrap: "wrap",
        },
    },
    cameraNavWrapper: {
        paddingTop: "1.1rem",
        minWidth: "25.2em",
    },
    clientLogo: {
        position: "absolute",
        opacity: "0.45",
        top: 10,
        left: 16,
        maxHeight: "6em",
        zIndex: 2,
    },
    fullScreen: {
        top: 10,
        right: 16,
    },
    panTilt: {
        paddingRight: 10,
    },
    ptz: {
        position: "absolute",
        bottom: 10,
        left: 16,
        display: "flex",
    },
    streamSectionWrapper: {
        width: "100%",
        minWidth: "40em",
        flexGrow: 1,
        paddingRight: "3.4375em",
        paddingLeft: "5.2em",
    },
    streamContainer: {
        position: "relative",
        overflow: "hidden",
    },
    fadeControls: {
        position: "absolute",
        height: "100%",
        width: "100%",
        opacity: 0.2,
        transition: "opacity 0.15s linear 0.5s",
        "&:hover": {
            opacity: 1,
            transitionDelay: "0s",
        },
    },
    centerAnimation: {
        position: "absolute",
        top: "calc(50% - 20px)",
        left: "calc(50% - 20px)",
        height: 60,
        width: 60,
        borderRadius: "50%",
        backgroundColor: "black",
        opacity: "70%",
    },
    upArrow: {
        transform: "rotate(.25turn)",
    },
    downArrow: {
        transform: "rotate(.75turn)",
    },
    leftArrow: {
        transform: "rotate(0turn)",
    },
    rightArrow: {
        transform: "rotate(.5turn)",
    },
}));
